export default __webpack_public_path__ + "2b909bbf0dca804c001f2e7a7f5fdc7c.png";